/* eslint-disable no-unused-vars */
/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable no-use-before-define */
/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */
import postman from '../../../utils/postman';

const Web = {
  closeWebView: () => {
    console.log('Load inside webview');
  },
  getCurrentLocation: () => {
    setTimeout(() => {
      postman.publish('LOCATION_RECEIVED', {
        errorCode: 200,
        coords: {
          latitude: '17.00',
          longitude: '75.00',
        },
      });
      return true;
    }, 1000);
  },
  getMiddleWareBaseUrlFromAndroid: () =>
    'https://goldengate-staging5.paytm.com/MerchantService/',
  getUADBaseUrlFromAndroid: () => 'https://uad-staging.paytm.com/uad/',
  getFSMBaseUrlFromAndroid: () => 'https://fse-staging.paytm.com/fse/',
  getCryptoKey: () => 'adasjdjakkk',
  getCommonHeaders: () => JSON.stringify({}),
  disableScreenshot: (isEnableScreenshot) => {
    console.log('disableScreenshot', isEnableScreenshot);
  },
  openFrontCamera: (height, width) => {
    console.log('web camera option', height, width);
  },
};
export const myInterface =
  typeof window.Android !== 'undefined'
    ? window.Android
    : typeof window.Ios !== 'undefined'
    ? window.Ios
    : Web;

/**
 * @return {*}
 */
export function closeWebView() {
  return myInterface.closeWebView();
}
/**
 * @param {*} jsonBody
 * @return {*}
 */
export function getAppHeaders() {
  return myInterface.getAppHeaders();
}

/**
 * @return {*}
 */
export function getCurrentLocation() {
  console.log('inside get current location');
  if (myInterface.getFSECurrentLocation) {
    return myInterface.getFSECurrentLocation(false);
  }
  if (myInterface.getCurrentLocation) {
    return myInterface.getCurrentLocation();
  }
  console.log('erro getiing current location');
  return false;
}

// need to test this code after deployment
export const getAndroidLocation = () =>
  new Promise((resolve, reject) => {
    console.log('calling getAndroidLocation');
    console.log(
      'check if interface exist',
      checkIfInterfaceExist('getCurrentLocation'),
    );
    if (checkIfInterfaceExist('getCurrentLocation')) {
      console.log('android bridge for location successfully call');
      window.onLocationReceived = (location) => {
        console.log('onLocationReceived call', location);
        const { errorCode, coords } = JSON.parse(location);
        if (errorCode === 200) resolve(coords);
        else reject(false);
      };
      getCurrentLocation();
    }
  });

/**
 * @return {*}
 */
export function getCommonHeaders() {
  console.log('inside get common headers');
  if (myInterface.getCommonHeaders) {
    return myInterface.getCommonHeaders();
  }
  console.log('error getting common headers');
  return false;
}

/**
 * @return {*}
 */
export function getMiddleWareBaseUrlFromAndroid() {
  console.log('inside get base url');
  if (myInterface.getMiddleWareBaseUrlFromAndroid) {
    return myInterface.getMiddleWareBaseUrlFromAndroid();
  }
  console.log('error getting base url');
  return false;
}

/**
 * @return {*}
 */
export function getUADBaseUrlFromAndroid() {
  console.log('inside get UAD url');
  if (myInterface.getUADBaseUrlFromAndroid) {
    return myInterface.getUADBaseUrlFromAndroid();
  }
  console.log('error getting UAD url');
  return false;
}

/**
 * @return {*}
 */
export function getFSMBaseUrlFromAndroid() {
  console.log('inside get FSM url');
  if (myInterface.getFSMBaseUrlFromAndroid) {
    return myInterface.getFSMBaseUrlFromAndroid();
  }
  console.log('error getting FSM url');
  return false;
}

/**
 * @return {*}
 */
export function getCryptoKey() {
  console.log('inside get crypto key');
  if (myInterface.getCryptoKey) {
    return myInterface.getCryptoKey();
  }
  console.log('error getting crypto key');
  return false;
}

/**
 * @param {Boolean} isEnableScreenshot
 * @return {void}
 */
export function disableScreenshot(isEnableScreenshot) {
  if (myInterface.disableScreenshot) {
    console.log('disableScreenshot function');
    return myInterface.disableScreenshot(isEnableScreenshot);
  }
}

/**
 * @return {*}
 * @param {*} interfaceName
 */
export function checkIfInterfaceExist(interfaceName) {
  if (myInterface[interfaceName]) {
    return true;
  }
  return false;
}

/**
 * @return {*}
 * @param {JSDoc} height
 * @param {*} width
 */
export function openFrontCamera(height, width) {
  if (myInterface.openFrontCamera) {
    console.log('open camera function');
    return myInterface.openFrontCamera();
  }

  console.log('error in open camera function');
  return false;
}

export function launchATSInventoryPage(id, custId) {
  if (myInterface.launchATSInventoryPage) {
    console.log('launchATSInventoryPage');
    return myInterface.launchATSInventoryPage(id, custId);
  }
  console.log('launchATSInventoryPage error');
  return false;
}
